import toast from 'react-hot-toast';
import { parseError, TOAST_DURATIONS } from '@lov/shared';

export interface ToastOptions {
  duration?: number;
}

/**
 * Toast notification hook using react-hot-toast
 */
export function useToast() {
  return {
    success: (message: string, options?: ToastOptions) => {
      toast.success(message, {
        duration: options?.duration ?? TOAST_DURATIONS.success,
        position: 'top-right',
        style: {
          background: '#10B981',
          color: '#FFFFFF',
        },
      });
    },

    error: (message: string, options?: ToastOptions) => {
      toast.error(message, {
        duration: options?.duration ?? TOAST_DURATIONS.error,
        position: 'top-right',
        style: {
          background: '#EF4444',
          color: '#FFFFFF',
        },
      });
    },

    info: (message: string, options?: ToastOptions) => {
      toast(message, {
        duration: options?.duration ?? TOAST_DURATIONS.info,
        position: 'top-right',
        icon: 'ℹ️',
        style: {
          background: '#3B82F6',
          color: '#FFFFFF',
        },
      });
    },

    warning: (message: string, options?: ToastOptions) => {
      toast(message, {
        icon: '⚠️',
        duration: options?.duration ?? TOAST_DURATIONS.warning,
        position: 'top-right',
        style: {
          background: '#F97316',
          color: '#FFFFFF',
        },
      });
    },

    /**
     * Show toast from any error (parses automatically)
     */
    showError: (error: unknown) => {
      const parsed = parseError(error);
      toast.error(parsed.message, {
        duration: TOAST_DURATIONS.error,
        position: 'top-right',
        style: {
          background: '#EF4444',
          color: '#FFFFFF',
        },
      });
    },

    dismiss: toast.dismiss,
  };
}
